import React from "react";
import { Link } from "react-router-dom";
import { timelineAbout, offices, stats } from "../mock";
import { Button } from "../components/ui/button";
import { MapPin } from "lucide-react";

export default function AboutPage() {
  return (
    <>
      <section className="bg-gradient-to-b from-slate-50 to-white py-16 md:py-24 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">About us</div>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0B2447] tracking-tight leading-[1.1]">Two decades protecting the brands people trust.</h1>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">Brand Marketing Professionals has been a trusted digital partner since 2003. Today, our reputation practice helps law firms, clinics, hotels and enterprises take back control of their online story—with a no-risk, results-only model.</p>
            <div className="mt-8 flex gap-3">
              <Link to="/contact"><Button className="bg-[#0B2447] hover:bg-[#122e5f] text-white h-11 px-5">Talk to a specialist</Button></Link>
              <Link to="/services"><Button variant="outline" className="h-11 px-5 border-slate-300 text-[#0B2447]">Explore services</Button></Link>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-slate-200 bg-white p-5">
                <div className="text-2xl md:text-3xl font-bold text-[#0B2447]">{s.number}</div>
                <div className="text-xs md:text-sm text-slate-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Our journey</div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0B2447] tracking-tight max-w-2xl">Built on results, trusted around the world</h2>
          <div className="mt-12 space-y-6">
            {timelineAbout.map((t) => (
              <div key={t.year} className="grid grid-cols-1 md:grid-cols-[120px_1fr] gap-4 md:gap-8 items-start border-b border-slate-100 pb-6">
                <div className="text-[#0B2447] font-bold text-lg">{t.year}</div>
                <div>
                  <div className="font-semibold text-[#0B2447]">{t.title}</div>
                  <div className="text-slate-600 mt-1">{t.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Our offices</div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0B2447] tracking-tight">Global reach, local expertise</h2>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {offices.map((o) => (
              <div key={o.country} className="rounded-2xl border border-slate-200 bg-white p-6">
                <div className="w-9 h-9 rounded-lg bg-[#0B2447]/5 flex items-center justify-center mb-4">
                  <MapPin className="w-4 h-4 text-[#0B2447]" />
                </div>
                <div className="font-semibold text-[#0B2447]">{o.country}</div>
                <div className="text-sm text-slate-600 mt-2 leading-relaxed">{o.address}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
